import { render, staticRenderFns } from "./PreviewNewModal.vue?vue&type=template&id=6a1d7c69&scoped=true"
import script from "./PreviewNewModal.vue?vue&type=script&lang=js"
export * from "./PreviewNewModal.vue?vue&type=script&lang=js"
import style0 from "./PreviewNewModal.vue?vue&type=style&index=0&id=6a1d7c69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1d7c69",
  null
  
)

export default component.exports